<template>
	<div class="job-detail">
		<div class="job-con">
			<ul class="require-con">
				<li class="x-flow"><h5 class="x-inline">{{ activePosInfo.activePosName }}</h5>
					<i class="x-icon-share x-inline"></i>
				</li>
				<li class="x-flow help-btn">
					<router-link to="" @click.native="go2Apply">
						<button>Apply Now</button>
					</router-link>
				</li>
			</ul>
			<ul class="require-list">
				<li>
					<h5>Job responsibilities</h5>
					<ul class="sub-con">
						<li v-for="(item,key) in activePosInfo.responsibility">
							{{key + 1}}. {{item}}
						</li>
						<!--<li>1.  负责伺服驱动的硬件设计，包括控制电路及功率电路；</li>
						<li>2. 负责原理图设计，配合LAYOUT工程师完成PCB设计；</li>
						<li>3. 负责电路调试，可靠性测试及产品周期中相关的硬件技术问题.；</li>
						<li>4. 负责EMC、安规认证等工作.</li>-->
					</ul>
				</li>
				<li>
					<h5>Job requirements</h5>
					<ul class="sub-con">
						<li v-for="(item,key) in activePosInfo.requirement">
							{{key + 1}}. {{item}}
						</li>
						<!--<li>1.  具备扎实的硬件电路基础知识，对数字电路、模拟电路以及MOS、IGBT等分立器件特性有较深的认识；</li>
						<li>2. 熟悉电机控制相关原理；</li>
						<li>3. 有驱动电路开发经验.</li>
						<li>4. 对ESD、EMC、产品可靠性设计有较好认识，有相关工作经验.</li>
						<li>5. 熟悉常见的调试设备使用方法.</li>-->
					</ul>
				</li>
			</ul>
		</div>
		<div class="job-pro">
			<div class="apply-con">
				<div class="help-lf" style="color: #FFFFFF;">
					Feel free to check the recruitment process or directly consult the Xhorse HR if you have any questions.
				</div>
			</div>
			<div class="help-rt">
				<router-link to="" @click.native="winLocateTo('https://jobs.51job.com/all/co3441454.html')">
					<button>Recruitment Process</button>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
    
    export default {
        props: {
            activePosInfo: {
                type: Object,
            },
            tagHeight: {
                type: Object
            }
        },
        data(){
            return {
                activeName: 2,
            };
        },
        methods: {
            go2Apply(){
                const _this = this;
                _this.$emit('go', {
                    type: 'apply', val: {
                        activePosId: _this.activePosInfo.activePosId,
                        activeName: 3
                    }
                });
            },
            winLocateTo(url){
                const _this = this;
                //window.location.href = url;
                window.open(url, "_blank");
            },
        },
        mounted(){
            const _this = this;
            _this.$emit('height', {
                type: 'screen', val: {
                    posListheight: '88.5625rem',
                    posConheight: '72.875rem',
                    listConheight: '62.8125rem',
                }
            })
        }
    }

</script>

<style scoped>
	.help-rt {
		position: absolute;
		right: 0;
	}

	.help-lf, .help-rt {
		display: block;
		height: 4.5rem;
		line-height: 4.5rem;
		float: left;
	}

	.apply-con {
		width: 60%;
		margin: 0 auto;
	}

	.help-rt button {
		height: 4.5rem;
		border: none;
		margin: 0;
		background: #F67920;
		color: #ffffff;
		/* border-radius: 4px; */
		width: 11.25rem;
		font-size: 1rem;
		line-height: 4.6875rem;
		outline: 0;
		cursor: pointer;
	}

	.job-detail {
		width: 100%;
		min-height: 53.9375rem;
	}

	.job-con {
		width: 77.5rem;
		min-height: 49.4375rem;
		margin: 0 auto;
	}

	.job-pro {
		width: 100%;
		height: 4.5rem;
		opacity: 0.8;
		background: #2B2B2B;
	}

	.require-con {
		height: 4.5rem;
		width: 100%;
		margin-top: 3.3125rem;
		line-height: 2.875rem;
	}

	.require-con li {
		height: 3.125rem;
		border: none;
	}

	.require-con li:nth-child(1) {
		width: 75%;
		text-align: left;
	}

	.require-con li {
		width: 25%;
		text-align: right;
	}

	.require-con li:nth-child(1) h5 {
		font-size: 2rem;
		text-align: left;
	}

	.require-con li:nth-child(1) i {
		font-size: 2rem;
		position: relative;
		top: .25rem;
	}

	.require-con li:nth-child(2) {
		text-align: right;
	}

	.require-list {
		margin-top: 3.25rem;
		overflow: hidden;
	}

	.require-list li {
		text-align: left;
	}

	.require-list h5 {
		font-family: PingFang-SC;
		font-size: 1.75rem;
		color: #2B2E2E;
		line-height: 2.75rem;
	}

	.require-list ul.sub-con {
		width: auto;
		min-height: 7.5rem;
		font-family: PingFang-SC;
		font-size: 1rem;
		color: #808080;
		line-height: 1.875rem;
		margin-top: 1.25rem;
		margin-bottom: 2.5rem;
	}

	.apply-help {
		background: #2B2B2B;
		opacity: 0.8;
		width: 100%;
		height: 5.25rem;
	}

	.apply-help .help-lf {
		width: 60%;
		margin: 0 auto;
		text-align: left;
		font-family: PingFang-MM;
		font-size: 1rem;
		color: #FFFFFF;
		line-height: 2.6875rem;
	}

	.apply-help .help-rt {
		position: absolute;
		right: 0;
	}

	.apply-con {
		width: 60%;
		margin: 0 auto;
	}

	.apply-help .help-rt button {
		height: 5.4375rem;
		border: none;
		margin: 0;
		background: #F67920;
		color: #ffffff;
		/* border-radius: 4px; */
		width: 157px;
		font-family: Open Sans;
		font-size: 1rem;
		line-height: 5.4375rem;
	}

	.apply-help .help-lf, .help-rt {
		display: inline-block;
		height: 4.5rem;
		line-height: 4.4375rem;
		float: left;
		border: none;
	}

	.x-icon-share {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_share.png");
		width: 2rem;
		height: 2rem;
	}

	.help-btn button {
		height: 2.875rem;
		border: none;
		margin: 0;
		background: #F67920;
		color: #ffffff;
		border-radius: .25rem;
		width: 9.8125rem;
		outline: 0;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/join/join-detail.vue